import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import useDeviceDetection from '../../hooks/useDeviceDetection';
import FooterSocialLinks from '../FooterSocialLinks/FooterSocialLinks';
import Link from '../Link';
import Logo from '../../public/images/logo-symbol.svg';
import { Column, ColumnLinks, ColumnTable, ColumnTitle, Wrapper } from './FooterSitemap.styles';

const FooterSitemap = ({ openingHours }) => {
  const { isDesktop, isDesktopL } = useDeviceDetection();
  const { t } = useTranslation('common');

  return (
    <Wrapper>
      {isDesktopL && (
        <Column>
          <Link href="/">
            <Logo />
          </Link>
        </Column>
      )}
      <Column>
        <ColumnTitle>{t('footer.links.title')}</ColumnTitle>
        <ColumnLinks>
          <li>
            <Link href={t('footer.links.downloadIosApp.link')}>{t('footer.links.downloadIosApp.label')}</Link>
          </li>
          <li>
            <Link href={t('footer.links.downloadAndroidApp.link')}>{t('footer.links.downloadAndroidApp.label')}</Link>
          </li>
        </ColumnLinks>
      </Column>
      <Column>
        <ColumnTitle>{t('footer.getInTouch.title')}</ColumnTitle>
        <ColumnLinks>
          <li>
            <a href={t('footer.links.phone.link')}>{t('footer.links.phone.label')}</a>
          </li>
          <li>
            <a href={t('footer.links.email.link')}>{t('footer.links.email.label')}</a>
          </li>
          <li>
            <a href={t('footer.links.whatsapp.link')}>{t('footer.links.whatsapp.label')}</a>
          </li>
        </ColumnLinks>
      </Column>
      <Column>
        <ColumnTitle>{t('footer.location.title')}</ColumnTitle>
        <address dangerouslySetInnerHTML={{ __html: t('footer.location.address').replace(/\n/g, '<br />') }} />
      </Column>
      {openingHours && (
        <Column>
          <ColumnTitle>{t('footer.openingHours.title')}</ColumnTitle>
          <ColumnTable>
            <tbody>
              {openingHours &&
                openingHours.map(row => (
                  <tr key={row.day}>
                    <td>{row.day}</td>
                    <td>{row.time}</td>
                  </tr>
                ))}
            </tbody>
          </ColumnTable>
        </Column>
      )}
      {isDesktop && (
        <Column>
          <FooterSocialLinks />
        </Column>
      )}
    </Wrapper>
  );
};

export default FooterSitemap;
